enum Role {
  OWNER = "OWNER",
  MANAGER = "MANAGER",
  MEMBER = "MEMBER",
  READ_ONLY = "READ_ONLY",
  READ_ONLY_WITH_EXPORTS = "READ_ONLY_WITH_EXPORTS",
}

export default Role;
